// Pure helpers for the in-app notification inbox (#133). The screen subscribes
// to users/{uid}/inbox; these sort and count without touching Firestore.

export interface InboxTimestamp {
  seconds: number;
  nanoseconds: number;
}

export interface InboxItem {
  id: string;
  type: string;
  title: string;
  body: string;
  read: boolean;
  createdAt?: InboxTimestamp;
  roomId?: string;
  clickAction?: string;
}

/** Epoch ms for an inbox item, or -Infinity when it has no timestamp. */
function createdAtMs(item: InboxItem): number {
  return item.createdAt ? item.createdAt.seconds * 1000 : -Infinity;
}

/**
 * Sort inbox items newest first, without mutating the input. Items with no
 * timestamp (not yet written server-side) sort last.
 */
export function sortInboxByNewest(items: InboxItem[]): InboxItem[] {
  return [...items].sort((a, b) => createdAtMs(b) - createdAtMs(a));
}

/** Number of unread items. */
export function countUnread(items: InboxItem[]): number {
  return items.filter((i) => !i.read).length;
}
